package one.healthium.bland

import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseUrls
import one.primehealth.app.FirebaseAppConfig
import one.primehealth.app.Flavour
import one.primehealth.app.PlatformValues

fun appConfig(flavour: Flavour) =
    BaseAppConfig(
        baseUrls = BaseUrls(
            content = when (flavour) {
                Flavour.Stage -> "https://bland-content-stage.web.app/"
                Flavour.Prod -> "https://bland-content-prod.web.app/"
            }
        ),
        intercomApiKey = PlatformValues(
            android = "android_sdk-376cc4ff3418a1fc242d34ef12e9c3d4ff8b9fa8",
            ios = "ios_sdk-1f273098a984821e01c616b73804fe92584b24d9",
            web = ""
        ),
        intercomAppKey = "qpjbxd63",
        intercomAppName = "BLAND",
        amplitudeKey = when (flavour) {
            Flavour.Stage -> ""
            Flavour.Prod -> ""
        },
        adaptyKey = "public_live_L57rqQ1t.bb0DaocPIkrUYyyANQdK",
        appsflyerKey = "obcS6CH7xbbq3Kgqd3xXUH",
        appleAppId = "6746741910",
        feedbackEmail = "bland@healthium.one",
        firebaseApp = when (flavour) {
            Flavour.Stage -> FirebaseAppConfig(
                applicationId = "1:482281885415:android:b7e2116f5a1d102a5e1c42",
                apiKey = "AIzaSyDBvNRYbb3p9G9OPpRmDTyrnC4Wbf8nhVg",
                projectId = "bland-diet-app-stage",
                storageBucket = "bland-diet-app-stage.firebasestorage.app",
                userStorageBucket = "gs://bland-diet-app-stage-users-data",
                authDomain = "bland-diet-app-stage.firebaseapp.com",
            )

            Flavour.Prod -> FirebaseAppConfig(
                applicationId = "1:656477123368:android:e8211ccab6d3097ef3161d",
                apiKey = "AIzaSyCjeVTnqa4J5d8Q4Mwsawi74gdZ6AhZ-Xo",
                projectId = "bland-diet-app-prod",
                storageBucket = "bland-diet-app-prod.firebasestorage.app",
                userStorageBucket = "gs://bland-diet-app-prod-users-data",
                authDomain = "bland-diet-app-prod.firebaseapp.com",
            )
        },
        appId = when (flavour) {
            Flavour.Stage -> "bland_stage"
            Flavour.Prod -> "bland"
        },
    )